import Accordeon from "../Components/Accordeon";
import "./App.css";

function App() {
  return (
    <div className="App">
      <Accordeon />
    </div>
  );
}

export default App;
